<template>
  <!-- 渠道能力评估 -->
  <div class="table_container">
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 网点名称 -->
      <el-table-column
        prop="outletsName"
        label="网点名称"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'outletsName' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.outletsName"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.outletsName }}
          </div>
        </template>
      </el-table-column>
      <!-- 店面类别 -->
      <el-table-column
        prop="storefrontType"
        label="店面类别"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'storefrontType' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.storefrontType"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.storefrontType }}
          </div>
        </template>
      </el-table-column>
      <!-- 店面选址说明(所处位置，周边竞品等) -->
      <el-table-column
        prop="storefrontAddress"
        label="店面选址说明(所处位置，周边竞品等)"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'storefrontAddress' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.storefrontAddress"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.storefrontAddress }}
          </div>
        </template>
      </el-table-column>
      <!-- 团队构成 -->
      <el-table-column
        prop="teamComposition"
        label="团队构成"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'teamComposition' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.teamComposition"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.teamComposition }}
          </div>
        </template>
      </el-table-column>
      <!-- 团队能力说明(投资人状态及市场人员能力、销售人员能力说明) -->
      <el-table-column
        prop="teamCapacityRemark"
        label="团队能力说明(投资人状态及市场人员能力、销售人员能力说明)"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'teamCapacityRemark' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.teamCapacityRemark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.teamCapacityRemark }}
          </div>
        </template>
      </el-table-column>
      <!-- 投资人投资汇报满意度说明(专营店：利润；综合店：收入、利润占比) -->
      <el-table-column
        prop="investorsSatisfiedRemark"
        label="投资人投资汇报满意度说明(专营店：利润；综合店：收入、利润占比)"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'investorsSatisfiedRemark' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.investorsSatisfiedRemark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.investorsSatisfiedRemark }}
          </div>
        </template>
      </el-table-column>
      <!-- 售后服务能力 -->
      <el-table-column
        prop="afterSaleServiceAbility"
        label="售后服务能力"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="
              editField === 'afterSaleServiceAbility' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.afterSaleServiceAbility"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="销服一体" value="销服一体"></el-option>
            <el-option label="合作售后服务" value="合作售后服务"></el-option>
            <el-option label="无售后" value="无售后"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.afterSaleServiceAbility }}
          </div>
        </template>
      </el-table-column>
      <!-- 与竞品的销量对标(同一区域的竞品门店销量对比；品牌、车型、销量) -->
      <el-table-column
        prop="competitionSaleBenchmarking"
        label="与竞品的销量对标(同一区域的竞品门店销量对比；品牌、车型、销量)"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'competitionSaleBenchmarking' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.competitionSaleBenchmarking"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.competitionSaleBenchmarking }}
          </div>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'remark' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.remark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.remark }}
          </div>
        </template>
      </el-table-column>
      <!-- 本月是否修改 -->
      <el-table-column
        prop="monthsUpdate"
        label="本月是否修改"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="editField === 'monthsUpdate' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.monthsUpdate"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.monthsUpdate ? scope.row.monthsUpdate : "否" }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateChannelAbilityEvaluationApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [], // 表格数据
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateChannelAbilityEvaluationApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data || [];
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
